import { createFileRoute } from '@tanstack/react-router';
import { areaRoute } from '../area-routes';
import { AreaView } from '../area-view';

export const Route = createFileRoute('/settings/$area')({
  ...areaRoute('/settings'),
  component: () => <AreaView base="/settings" />,
});
